import React from 'react';
import { ExternalLink } from 'lucide-react';
import { getIntlLocale } from '../../../i18n/runtime';

export default function EventList({ connected, events }) {
  if (!connected) return null;

  return (
    <section>
      <h2 className="text-xs font-semibold uppercase text-[#6B6B6B] mb-2">Google events</h2>
      {events.length === 0 ? (
        <div className="border border-dashed border-[#E3E2E0] rounded-xl p-6 text-sm text-[#6B6B6B]">
          No Google events found for the current window.
        </div>
      ) : (
        <div className="border border-[#E3E2E0] rounded-xl overflow-hidden bg-white">
          {events.map((event) => (
            <EventRow key={event.id || event.htmlLink} event={event} />
          ))}
        </div>
      )}
    </section>
  );
}

function EventRow({ event }) {
  const startValue = event?.start?.dateTime || event?.start?.date;
  const start = startValue ? new Date(startValue) : null;
  return (
    <div className="flex items-center gap-4 px-4 py-3 border-b last:border-b-0 border-[#E3E2E0]">
      <div className="w-14 text-center">
        <div className="text-[10px] uppercase text-[#6B6B6B]">
          {start && !Number.isNaN(start.getTime()) ? start.toLocaleDateString(getIntlLocale(), { month: 'short' }) : '--'}
        </div>
        <div className="text-2xl font-semibold text-[#191919] leading-none">
          {start && !Number.isNaN(start.getTime()) ? start.getDate() : '--'}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-[#191919] truncate">{event.summary || 'Google event'}</div>
        <div className="text-xs text-[#6B6B6B] truncate">
          {start && !Number.isNaN(start.getTime()) ? start.toLocaleString(getIntlLocale()) : 'No start time'}
        </div>
      </div>
      {event.htmlLink && (
        <a href={event.htmlLink} target="_blank" rel="noreferrer" className="p-2 rounded-lg hover:bg-[#F0F0EF]" title="Open Google event">
          <ExternalLink className="w-4 h-4 text-[#0052CC]" />
        </a>
      )}
    </div>
  );
}
